const keyCodes = {
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  capslock: 20,
  esc: 27,
  space: 32,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  metaLeft: 91,
  metaRight: 93,
}

export const isNavigateButton = function (code) {
  const navigateCodes = [
    keyCodes.tab,
    keyCodes.enter,
    keyCodes.shift,
    keyCodes.ctrl,
    keyCodes.alt,
    keyCodes.capslock,
    keyCodes.esc,
    keyCodes.space,
    keyCodes.arrowUp,
    keyCodes.arrowDown,
    keyCodes.arrowLeft,
    keyCodes.arrowRight,
    keyCodes.metaLeft,
    keyCodes.metaRight
  ];
  return navigateCodes.includes(code);
}

export default keyCodes
